import React from 'react';
import { useLocale } from 'locale';
import { useField } from 'react-final-form-hooks';
import { TextField } from 'ds/components/input/TextField';
import { withValidationMessage } from 'hocs/withValidationMessage';
import { ReportFormWrapper } from './styled';
import { ReportFormProps } from './interfaces';


const WithValidationTextField = withValidationMessage(TextField);

export const ReportForm: React.FC<ReportFormProps> = props => {
  const { formInstance } = props;
  const { t } = useLocale();
  const addressName = useField('addressName', formInstance);
  const commentMessage = useField('commentMessage', formInstance);
  const userEmail = useField('userEmail', formInstance);

  return (
    <ReportFormWrapper>
      <div>
        <WithValidationTextField
          {...addressName.input}
          {...addressName.meta}
          type="text"
          fullWidth
          label={t('reportAddress.popup.addressName.label')}
          placeholder={t('reportAddress.popup.addressName.placeholder')}
          hasError={Boolean(addressName.meta.invalid && addressName.meta.touched)}
        />
      </div>
      <div>
        <WithValidationTextField
          {...commentMessage.input}
          {...commentMessage.meta}
          type="text"
          fullWidth
          multiline
          rows={5}
          label={t('reportAddress.popup.message.label')}
          placeholder={t('reportAddress.popup.message.placeholder')}
        />
      </div>
      <div>
        <WithValidationTextField
          {...userEmail.input}
          {...userEmail.meta}
          type="email"
          fullWidth
          label={t('reportAddress.popup.email.label')}
          placeholder={t('reportAddress.popup.email.placeholder')}
          hasError={Boolean(userEmail.meta.invalid && userEmail.meta.touched)}
        />
      </div>
    </ReportFormWrapper>
  );
};
